import {connect} from 'react-redux'
import * as action from '../state/action'
import * as selector from '../state/selector'
import LowNpsReasonWidget from './LowNpsReasonWidget';

const mapStateToProps = (state, props) => {
    return {
        lowNpsReasonList: selector.selectLowNpsReasonList(state),
        taskName: props.taskName,
        feedbackCreated: selector.selectCreated(state),
        feedbackScore: selector.selectScore(state),
    };
};

const mapDispatchToProps = {
    toggleLowNpsReason: action.toggleLowNpsReason,
    saveLowNpsReason: action.saveLowNpsReason,
    getFeedback: action.getFeedback,
};

export default connect(mapStateToProps, mapDispatchToProps)(LowNpsReasonWidget);



// WEBPACK FOOTER //
// ./src/modules/feedback/component/LowNpsReasonWidgetContainer.js